(function () {
  // =========================
  // Config
  // =========================
  const MAX_PREFETCH = 6;          // was 4
const PREFETCH_WIDTHS = [800, 1200, 1600]; // add a larger size for retina hero

  // =========================
  // Helpers
  // =========================
  const norm = (v) =>
    (v || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/ä/g, "ae")
      .replace(/ö/g, "oe")
      .replace(/ü/g, "ue")
      .replace(/ß/g, "ss")
      .replace(/\s+/g, " ");

  const qs  = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const hardShow = (el, ok) => {
    if (!el) return;
    el.style.setProperty("display", ok ? "" : "none", "important");
    el.hidden = !ok;
    el.setAttribute("aria-hidden", ok ? "false" : "true");
    el.dataset.vgfVisible = ok ? "1" : "0";
  };

  // Scope to product root
  const productRoot =
    qs("[data-product-root]") ||
    qs("[data-product]") ||
    qs('[data-section-type*="product"]') ||
    qs('section[id*="product"]') ||
    qs(".product") ||
    document;

  // =========================
  // Detect option groups (Combine aware)
  // =========================
  const detectGroups = () => {
    const groups = [];
    const containers = qsa(
      [
        "[data-option-name]",
        ".product-variant", // Combine
        "fieldset",
        ".product-option",
        ".product__option",
        ".option-selector",
      ].join(","),
      productRoot
    );

    containers.forEach((el) => {
      let raw = "";
      if (el.hasAttribute?.("data-option-name")) raw = el.getAttribute("data-option-name") || "";

      if (!raw) {
        const withAttr = el.querySelector("[data-option-name]");
        if (withAttr) raw = withAttr.getAttribute("data-option-name") || "";
      }

      if (!raw) {
        const labelEl =
          el.querySelector(".product-variant__name") ||
          el.querySelector("legend, .product-option__name, .option-title, label[for]");
        if (labelEl) raw = (labelEl.textContent || "").trim();
      }

      raw = (raw || "").trim();
      if (!raw) return;

      const label = norm(raw);
      let type = "";
      if (label.includes("farbe") || label.includes("color")) type = "farbe";
      if (label.includes("grösse") || label.includes("groesse") || label.includes("größe") || label.includes("size")) type = "groesse";
      if (!type) return;

      groups.push({ el, type });
    });

    if (!groups.length) {
      const sets = qsa(".product-variant, fieldset, .product-option, .product__option", productRoot);
      if (sets[0]) groups.push({ el: sets[0], type: "farbe" });
      if (sets[1]) groups.push({ el: sets[1], type: "groesse" });
    }
    return groups;
  };

  const readSelectedFromGroup = (groupEl) => {
    const r = groupEl.querySelector('input[type="radio"]:checked');
    if (r?.value) return r.value;

    const s = groupEl.querySelector("select");
    if (s?.value) return s.value;

    const btn =
      groupEl.querySelector('[aria-pressed="true"]') ||
      groupEl.querySelector('[aria-checked="true"]') ||
      groupEl.querySelector("[data-selected='true']") ||
      groupEl.querySelector(".is-selected, .selected, .active");
    if (btn) {
      const v = btn.getAttribute("data-value") || btn.getAttribute("value") || btn.textContent;
      if (v) return v.trim();
    }

    const checkedLabel = groupEl.querySelector('input[type="radio"]:checked + label');
    if (checkedLabel) return checkedLabel.textContent.trim();

    const cur = groupEl.querySelector('[role="option"][aria-selected="true"]');
    if (cur) return (cur.getAttribute("data-value") || cur.textContent || "").trim();

    return "";
  };

  const getSelected = () => {
    const groups = detectGroups();
    let farbe = "", groesse = "";
    groups.forEach((g) => {
      const val = readSelectedFromGroup(g.el);
      if (!val) return;
      if (g.type === "farbe")  farbe  = norm(val);
      if (g.type === "groesse") groesse = norm(val);
    });
    return { farbe, groesse };
  };

  // =========================
  // Vocab for smart inference (from UI)
  // =========================
  const getVocab = () => {
    const vocab = { farbe: [], groesse: [] };
    const groups = detectGroups();

    const grabAllValues = (el) => {
      const vals = new Set();
      qsa('input[type="radio"]', el).forEach((r) => {
        if (r.value) vals.add(r.value.trim());
        const lab = r.nextElementSibling;
        if (lab && lab.tagName === "LABEL" && lab.textContent) vals.add(lab.textContent.trim());
      });
      qsa('[role="option"], button, [data-value], option', el).forEach((n) => {
        const v = n.getAttribute?.("data-value") || n.getAttribute?.("value") || n.textContent;
        if (v) vals.add(v.trim());
      });
      const s = el.querySelector("select");
      if (s) qsa("option", s).forEach((o) => {
        const v = (o.textContent || o.value || "").trim();
        if (v) vals.add(v);
      });
      return Array.from(vals);
    };

    groups.forEach((g) => {
      const list = grabAllValues(g.el).map((v) => norm(v));
      if (g.type === "farbe") vocab.farbe.push(...list);
      if (g.type === "groesse") vocab.groesse.push(...list);
    });

    vocab.farbe   = Array.from(new Set(vocab.farbe));
    vocab.groesse = Array.from(new Set(vocab.groesse));
    return vocab;
  };

  // =========================
  // Parse tags from ALT (tolerant) + fallback inference
  // =========================
  // Accepts: "#Farbe:...", "#Grösse:...", "#farbe_...", "#size ..." (case-insensitive)
  const parseTags = (alt) => {
    const out = { farbe: null, groesse: null };
    const txt = norm(alt || "");

    // 1) strict hashtag syntax (supports :, _, -, or space after key)
    const re = /#\s*(farbe|color|groesse|größe|size)\s*[:_\-\s]+\s*([^#]+)/gi;
    let m;
    while ((m = re.exec(txt))) {
      const keyRaw = (m[1] || "").toLowerCase();
      const key = keyRaw.startsWith("f") || keyRaw === "color" ? "farbe" : "groesse";
      out[key] = norm(m[2]);
    }
    if (out.farbe || out.groesse) return out;

    // 2) fallback: smart inference by string inclusion
    const vocab = getVocab();
    const byLenDesc = (arr) => arr.slice().sort((a, b) => b.length - a.length);
    for (const val of byLenDesc(vocab.farbe))   { if (val && txt.includes(val))   { out.farbe = val; break; } }
    for (const val of byLenDesc(vocab.groesse)) { if (val && txt.includes(val)) { out.groesse = val; break; } }
    return out;
  };

  // =========================
  // Collect gallery items (Combine wrappers)
  // =========================
  const collectMedia = () => {
    const imgs = qsa(
      [
        ".product-gallery-item img",      // Combine’s main wrapper
        "[data-product-media] img",
        "[data-media-id] img",
        ".product__media img",
        ".product-media img",
        ".media img",
        ".gallery img",
        ".product-gallery img",
      ].join(","),
      productRoot
    );

    return imgs.reduce((acc, img) => {
      const wrap =
        img.closest(".product-gallery-item") ||
        img.closest("[data-product-media]") ||
        img.closest("[data-media-id]") ||
        img.closest(".product__media-item") ||
        img.closest(".product-media-item") ||
        img.closest(".gallery__item") ||
        img.closest("li") ||
        img.closest("figure") ||
        img.parentElement;

      if (wrap && !acc.find((x) => x.wrap === wrap)) {
        acc.push({ img, wrap, idx: acc.length });
      }
      return acc;
    }, []);
  };

  // =========================
  // Image priority tuning (hero high, others lazy)
  // =========================
  const tuneImagePriority = () => {
    const tiles = qsa(".product-gallery-item");
    const imgs  = qsa(".product-gallery-item img");

    // reset all
    imgs.forEach((img) => {
      img.setAttribute("loading", "lazy");
      img.removeAttribute("fetchpriority");
      img.setAttribute("decoding", "async");
    });

    // first visible = hero
    const firstVisible = tiles.find((el) => getComputedStyle(el).display !== "none");
    const hero = firstVisible?.querySelector("img");
    if (hero) {
      hero.setAttribute("fetchpriority", "high");
      hero.setAttribute("loading", "eager");
      hero.setAttribute("decoding", "async");
      if (!hero.hasAttribute("sizes")) {
        hero.setAttribute("sizes", "(min-width:1024px) 66vw, 100vw");
      }
    }
  };

  // =========================
  // Prefetch utilities
  // =========================
  const prefetchURL = (url) => {
    if (!url) return;
    if (document.head.querySelector(`link[rel="prefetch"][href="${url}"]`)) return;
    const l = document.createElement("link");
    l.rel = "prefetch";
    l.as = "image";
    l.href = url;
    document.head.appendChild(l);
  };

  const bestSrcs = (img) => {
    const out = new Set();
    if (img.currentSrc) out.add(img.currentSrc);
    if (img.src) out.add(img.src);

    const set = img.getAttribute("srcset") || "";
    if (set) {
      const parts = set.split(",").map((s) => s.trim());
      const entries = parts
        .map((p) => {
          const m = p.match(/(\S+)\s+(\d+)w$/);
          return m ? { url: m[1], w: parseInt(m[2], 10) } : null;
        })
        .filter(Boolean);
      PREFETCH_WIDTHS.forEach((target) => {
        let best = null,
          bestDelta = Infinity;
        entries.forEach((e) => {
          const d = Math.abs(e.w - target);
          if (d < bestDelta) {
            best = e;
            bestDelta = d;
          }
        });
        if (best) out.add(best.url);
      });
    }
    return Array.from(out);
  };

  const prefetchLikelyNext = ({ farbe, groesse }) => {
    const tiles = qsa(".product-gallery-item");
    const classified = tiles.map((tile) => {
      const img = tile.querySelector("img");
      const tags = parseTags(img?.getAttribute("alt") || "");
      const visible = getComputedStyle(tile).display !== "none";
      return { tile, img, tags, visible };
    });

    const candidates = [];

    // 1) same color, other size (if size exists)
    if (farbe) {
      classified.forEach((it) => {
        if (it.visible) return;
        if (it.tags.farbe === farbe && it.tags.groesse && it.tags.groesse !== groesse) {
          candidates.push(it);
        }
      });
    }

    // 2) same variant additional angles
    if (farbe || groesse) {
      classified.forEach((it) => {
        if (it.visible) return;
        const sameF = farbe ? it.tags.farbe === farbe : true;
        const sameG = groesse ? it.tags.groesse === groesse : true;
        if (sameF && sameG && (it.tags.farbe || it.tags.groesse)) candidates.push(it);
      });
    }

    // 3) globals (no tags)
    classified.forEach((it) => {
      if (it.visible) return;
      if (!it.tags.farbe && !it.tags.groesse) candidates.push(it);
    });

    // Dedup + cap
    const uniqueImgs = [];
    const seen = new Set();
    for (const c of candidates) {
      const img = c.img;
      if (!img) continue;
      const key = img.currentSrc || img.src || img.getAttribute("srcset") || Math.random().toString();
      if (seen.has(key)) continue;
      seen.add(key);
      uniqueImgs.push(img);
      if (uniqueImgs.length >= MAX_PREFETCH) break;
    }

    uniqueImgs.forEach((img) => bestSrcs(img).forEach(prefetchURL));
  };

  // =========================
  // Filter (enforce: only matching variant + globals)
  // =========================
  const filter = () => {
    const sel = getSelected();
    const { farbe, groesse } = sel;
    const items = collectMedia();
    const thumbsRoot = productRoot.querySelector(".product-gallery__thumbnails");

    const isMatch = (tags) => {
      if (tags.farbe && tags.groesse) return tags.farbe === norm(farbe) && tags.groesse === norm(groesse);
      if (tags.farbe && !tags.groesse) return tags.farbe === norm(farbe);
      if (!tags.farbe && tags.groesse) return tags.groesse === norm(groesse);
      return false;
    };

    const tagged = [];
    const globals = [];
    for (const it of items) {
      const tags = parseTags(it.img.getAttribute("alt") || "");
      if (tags.farbe || tags.groesse) tagged.push({ ...it, tags });
      else globals.push(it);
    }

    const variantMatches = tagged.filter(({ tags }) => isMatch(tags));
    const keptGlobals = globals; // alle globalen Bilder anzeigen
    const keptSet = new Set([...keptGlobals.map((i) => i.wrap), ...variantMatches.map((i) => i.wrap)]);

    items.forEach(({ wrap, idx }) => {
      const visible = keptSet.has(wrap);
      hardShow(wrap, visible);
      if (thumbsRoot) {
        const thumbBtn = thumbsRoot.querySelector(`.thumbnail[data-index="${idx}"]`);
        if (thumbBtn) hardShow(thumbBtn, visible);
      }
    });

    // Performance & UX boosts
    tuneImagePriority();
    prefetchLikelyNext(sel);
  };

  // =========================
  // Bind events + observer
  // =========================
  window.__vgfLoaded = true;
  window.vgfFilter = filter;

  const prefetchOnIntent = (e) => {
    const root = e.target.closest(".product-variant, [data-option-name]");
    if (!root) return;
    const intended = getSelected(); // start from current
    const val = e.target.getAttribute?.("data-value") || e.target.getAttribute?.("value") || e.target.textContent || "";
    const labelEl = root.querySelector("[data-option-name], .product-variant__name, legend, .option-title");
    const label = (labelEl?.getAttribute?.("data-option-name") || labelEl?.textContent || "").toLowerCase();
    if (val) {
      if (label.includes("farbe") || label.includes("color")) intended.farbe = norm(val);
      if (label.includes("grösse") || label.includes("groesse") || label.includes("größe") || label.includes("size"))
        intended.groesse = norm(val);
      prefetchLikelyNext(intended);
    }
  };

  const startObserver = () => {
    const target = productRoot.querySelector(".product-gallery") || productRoot;
    if (!target) return;

    const obs = new MutationObserver(() => {
      clearTimeout(startObserver._t);
      startObserver._t = setTimeout(filter, 60);
    });

    obs.observe(target, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["class", "src", "style"],
    });
  };

  const bind = () => {
    productRoot.addEventListener("change", filter, true);
    productRoot.addEventListener(
      "click",
      (e) => {
        const t = e.target;
        if (!t) return;
        if (
          t.matches('input[type="radio"], select, button, [role="option"], [aria-pressed], [aria-checked]') ||
          t.closest("label, button, [role='option']")
        ) {
          // single debounced call
          clearTimeout(bind._t);
          bind._t = setTimeout(filter, 120);
        }
      },
      true
    );

    // Warm on intent (hover/focus swatch)
    productRoot.addEventListener("mouseover", prefetchOnIntent, true);
    productRoot.addEventListener("focusin", prefetchOnIntent, true);
productRoot.addEventListener('pointerenter', prefetchOnIntent, true);
productRoot.addEventListener('touchstart', prefetchOnIntent, { capture: true, passive: true });

    // initial + delayed + observer
    filter();
    setTimeout(filter, 200);
    setTimeout(filter, 800);
    startObserver();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }

  console.log("[VGF] loaded (Combine • strict filter • hero priority • prefetch)");
})();
